import React from 'react';

export default function CustomIcon({ fill = '#FBBC55', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M44.0398 33.6396L37.7798 18.9996C36.6398 16.3196 34.9398 14.7996 32.9998 14.6996C31.0798 14.5996 29.2198 15.9396 27.7998 18.4996L23.9998 25.3196C23.1998 26.7596 22.0598 27.6196 20.8198 27.7196C19.5598 27.8396 18.2998 27.1796 17.2798 25.8796L16.8398 25.3196C15.4198 23.5396 13.6598 22.6796 11.8598 22.8596C10.0598 23.0396 8.51979 24.2796 7.49979 26.2996L4.03979 33.1996C2.79979 35.6996 2.91979 38.5996 4.37979 40.9596C5.83979 43.3196 8.37979 44.7396 11.1598 44.7396H36.6798C39.3598 44.7396 41.8598 43.3996 43.3398 41.1596C44.8598 38.9196 45.0998 36.0996 44.0398 33.6396Z"
                fill={fill}
            />
            <path
                d="M13.9402 16.7602C17.6736 16.7602 20.7002 13.7337 20.7002 10.0002C20.7002 6.26679 17.6736 3.24023 13.9402 3.24023C10.2067 3.24023 7.18018 6.26679 7.18018 10.0002C7.18018 13.7337 10.2067 16.7602 13.9402 16.7602Z"
                fill={fill}
            />
        </svg>
    );
}
